var _path, _path2, _g, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatusLive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36.3936C27.9411 36.3936 36 28.3347 36 18.3936C36 8.45243 27.9411 0.393555 18 0.393555C8.05887 0.393555 0 8.45243 0 18.3936C0 28.3347 8.05887 36.3936 18 36.3936Z",
    fill: "url(#paint0_linear_14694_34040)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5094 22.7612H10.4906C9.45541 22.7612 8.61328 23.6023 8.61328 24.6361V27.1359C8.61328 28.1698 9.45541 29.0108 10.4906 29.0108H25.5094C26.5446 29.0108 27.3867 28.1698 27.3867 27.1359V24.6361C27.3867 23.6023 26.5446 22.7612 25.5094 22.7612ZM11.7422 26.5109C11.3966 26.5109 11.1164 26.2311 11.1164 25.8859C11.1164 25.5408 11.3966 25.261 11.7422 25.261C12.0878 25.261 12.368 25.5408 12.368 25.8859C12.368 26.2311 12.0878 26.5109 11.7422 26.5109ZM14.2453 26.5109C13.8997 26.5109 13.6195 26.2311 13.6195 25.8859C13.6195 25.5408 13.8997 25.261 14.2453 25.261C14.5909 25.261 14.8711 25.5408 14.8711 25.8859C14.8711 26.2311 14.5909 26.5109 14.2453 26.5109ZM16.7484 26.5109C16.4029 26.5109 16.1227 26.2311 16.1227 25.8859C16.1227 25.5408 16.4029 25.261 16.7484 25.261C17.094 25.261 17.3742 25.5408 17.3742 25.8859C17.3742 26.2311 17.094 26.5109 16.7484 26.5109ZM14.2453 14.0119H16.1227V18.3865C16.1227 18.732 16.4026 19.0115 16.7484 19.0115H19.2516C19.5974 19.0115 19.8773 18.7319 19.8773 18.3865V14.0118H21.7547C21.9918 14.0118 22.2081 13.8782 22.3144 13.6664C22.4202 13.4546 22.3976 13.2013 22.2552 13.0121L18.5005 8.01256C18.2646 7.69763 17.7353 7.69763 17.4995 8.01256L13.7448 13.0121C13.6024 13.2013 13.5798 13.4546 13.6856 13.6664C13.7919 13.8782 14.0082 14.0119 14.2453 14.0119ZM19.2516 20.2614H16.7484C16.4026 20.2614 16.1227 20.5409 16.1227 20.8864C16.1227 21.2318 16.4026 21.5113 16.7484 21.5113H19.2516C19.5974 21.5113 19.8773 21.2317 19.8773 20.8864C19.8773 20.5409 19.5974 20.2614 19.2516 20.2614Z",
    fill: "url(#paint1_linear_14694_34040)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14694_34040)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.3053,
    cy: 16.5856,
    r: 6.46154,
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5391 17.0605L30.9282 18.4497L35.0956 14.2823",
    stroke: "#6E4ADA",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14694_34040",
    x: 17.8438,
    y: 3.12402,
    width: 28.9219,
    height: 28.9229,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14694_34040"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14694_34040",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14694_34040",
    x1: 18,
    y1: 36.3936,
    x2: 18,
    y2: 0.393555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14694_34040",
    x1: 18,
    y1: 29.0108,
    x2: 18,
    y2: 7.77638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A16CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77D4FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusLive);
export default __webpack_public_path__ + "static/media/status_live.c0aa88a7c64c18599850a4bcf3eb019e.svg";
export { ForwardRef as ReactComponent };